import { defineStore } from 'pinia';
import { SuborganizationEntity } from '@/types/organization/suborganization.entity';
import SuborganizationService from '@/services/coda-qa-user/suborganization.service';
import { useFetch } from '@/composables/fetch/useFetch';
import { useOrganization } from '@/composables/useOrganization';
import { computed, ref } from 'vue';
import { useUserStore } from '@/store/modules/user/useUserStore';

export const useOrganizationStore = defineStore('organizations', () => {
  const { getCurrentOrgFromLocalStorage, setCurrentOrgInLocalStorage } = useOrganization();

  const userStore = useUserStore();

  const warehouses = ref<SuborganizationEntity[]>([]);
  const setWarehouses = (_warehouses: SuborganizationEntity[]) => {
    warehouses.value = _warehouses.filter((warehouse) =>
      userStore.currentUser?.subOrganizations.includes(warehouse.id)
    );
  };

  const currentWarehouse = ref<SuborganizationEntity | null>(null);
  const setCurrentWarehouse = (warehouse: SuborganizationEntity | null) => {
    currentWarehouse.value = warehouse;
    setCurrentOrgInLocalStorage(warehouse?.id);
  };

  const { loading: loadingWarehouse, callFetch: fetchWarehouses } = useFetch(async () => {
    const { data } = await SuborganizationService.getAll();

    setWarehouses(data);

    const currentWarehouseId = getCurrentOrgFromLocalStorage();

    const warehouse =
      currentWarehouseId && userStore.currentUser?.subOrganizations.includes(currentWarehouseId)
        ? warehouses.value.find((warehouse) => warehouse.id === currentWarehouseId)
        : warehouses.value.slice().shift();

    setCurrentWarehouse(warehouse ?? null);
  });

  const currentOrganizationTimeZone = computed(() => {
    return currentWarehouse.value?.general?.timeZone;
  });

  return {
    warehouses,
    currentWarehouse,
    loadingWarehouse,
    currentOrganizationTimeZone,
    fetchWarehouses,
    setCurrentWarehouse,
  };
});
